export const alertTypes = {
    AlertLoad: "[Alerts] Load alerts",
    AlertDelete: "[Alerts] Delete alerts",
};
